import React from 'react';
import { ButtonOptionsStyle } from './style';

export default function ButtonOptions({ buttonName, border, yourFunction, disabled = false, active = false }) {
  const handleClick = () => {
    if (yourFunction) {
      yourFunction();
    }
    return;
  };

  return (
    <ButtonOptionsStyle border={border} onClick={handleClick} disabled={disabled} active={active}>
      {buttonName}
    </ButtonOptionsStyle>
  );
}
